"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFontStyle = exports.SmallText = exports.Monospace = exports.Header6 = exports.Header5 = exports.Header4 = exports.Header3 = exports.Header2 = exports.Header1 = exports.ExtraSmallText = exports.ExtraExtraSmallText = exports.BaseText = exports.Base = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _recompose = require("recompose");
var _classnames = _interopRequireDefault(require("classnames"));
var _injectSheet = _interopRequireDefault(require("../style/injectSheet"));
var _ThemeTypes = require("../style/ThemeTypes");
var _excluded = ["classes", "className", "theme"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /*:: import type { ComponentType, ElementType, Node } from 'react';*/
/*:: import { type ThemeType, type typography } from '../style/ThemeTypes';*/
/*:: export type TextType = {
  children?: Node,
  component?: ElementType
};*/
var createFontStyle = exports.createFontStyle = function createFontStyle(style /*: typography*/, component /*: string*/, DISPLAY_NAME /*: string*/) {
  return /*: ComponentType<TextType>*/(0, _recompose.compose)((0, _recompose.setDisplayName)(DISPLAY_NAME), (0, _recompose.defaultProps)({
    component: component
  }), (0, _injectSheet.default)(function (theme /*: ThemeType*/) {
    return {
      fontStyle: _objectSpread({}, theme.typography[style])
    };
  }), (0, _recompose.mapProps)(function (_ref) {
    var classes = _ref.classes,
      className = _ref.className,
      theme = _ref.theme,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
    return _objectSpread({
      className: (0, _classnames.default)(classes.fontStyle, className)
    }, props);
  }), (0, _recompose.withProps)(function (props) {
    return _objectSpread({
      'data-displayname': DISPLAY_NAME
    }, props);
  }))((0, _recompose.componentFromProp)('component'));
};
var Base = exports.Base = createFontStyle(_ThemeTypes.TYPOGRAPHY.BASE, 'span', 'Base');
var Header1 = exports.Header1 = createFontStyle(_ThemeTypes.TYPOGRAPHY.HEADER1, 'h1', 'Header1');
var Header2 = exports.Header2 = createFontStyle(_ThemeTypes.TYPOGRAPHY.HEADER2, 'h2', 'Header2');
var Header3 = exports.Header3 = createFontStyle(_ThemeTypes.TYPOGRAPHY.HEADER3, 'h3', 'Header3');
var Header4 = exports.Header4 = createFontStyle(_ThemeTypes.TYPOGRAPHY.HEADER4, 'h4', 'Header4');
var Header5 = exports.Header5 = createFontStyle(_ThemeTypes.TYPOGRAPHY.HEADER5, 'h5', 'Header5');
var Header6 = exports.Header6 = createFontStyle(_ThemeTypes.TYPOGRAPHY.HEADER6, 'h6', 'Header6');
var BaseText = exports.BaseText = createFontStyle(_ThemeTypes.TYPOGRAPHY.BASETEXT, 'p', 'BaseText');
var SmallText = exports.SmallText = createFontStyle(_ThemeTypes.TYPOGRAPHY.SMALLTEXT, 'span', 'SmallText');
var ExtraSmallText = exports.ExtraSmallText = createFontStyle(_ThemeTypes.TYPOGRAPHY.EXTRASMALLTEXT, 'span', 'ExtraSmallText');
var ExtraExtraSmallText = exports.ExtraExtraSmallText = createFontStyle(_ThemeTypes.TYPOGRAPHY.EXTRAEXTRASMALLTEXT, 'span', 'ExtraExtraSmallText');
var Monospace = exports.Monospace = createFontStyle(_ThemeTypes.TYPOGRAPHY.MONOSPACE, 'pre', 'Monospace');
//# sourceMappingURL=Text.js.map